import { ColorProps } from 'types';

// ==============================|| CP0X THEME COLORS ||============================== //

const themeCp0x: ColorProps = {
  // paper & background
  paper: '#ffffff',

  // primary
  primaryLight: '#2cffff26',
  primaryMain: '#28e5e5',
  primaryDark: '#19b4b4',
  primary200: '#2cffff80',
  primary800: '#19b4b4cc',

  // secondary
  secondaryLight: '#2cffff26',
  secondaryMain: '#28e5e5',
  secondaryDark: '#19b4b4',
  secondary200: '#2cffff80',
  secondary800: '#19b4b4cc',

  // success
  successLight: '#23d92b26',
  success200: '#23d92b80',
  successMain: '#23d92b',
  successDark: '#23d92b80',

  // error
  errorLight: '#ef9a9a',
  errorMain: '#f44336',
  errorDark: '#c62828',

  // orange
  orangeLight: '#fbe9e7',
  orangeMain: '#ffab91',
  orangeDark: '#d84315',

  // warning
  warningLight: '#fff8e1',
  warningMain: '#ffe57f',
  warningDark: '#ffc107',

  // grey
  grey50: '#eeeeee',
  grey100: '#dddddd',
  grey200: '#c8c8c8',
  grey300: '#969696',
  grey500: '#646464',
  grey600: '#525f66',
  grey700: '#39454b',
  grey900: '#16161f',

  // ==============================|| DARK THEME VARIANTS ||============================== //

  // paper & background
  darkBackground: '#16161f',
  darkPaper: '#1e1e26',

  // dark levels
  darkLevel1: '#39454b3d',
  darkLevel2: '#16161f',

  // primary dark
  darkPrimaryLight: '#2cffff26',
  darkPrimaryMain: '#28e5e5',
  darkPrimaryDark: '#19b4b4',
  darkPrimary200: '#2cffff80',
  darkPrimary800: '#19b4b4cc',

  // secondary dark
  darkSecondaryLight: '#2cffff26',
  darkSecondaryMain: '#28e5e5',
  darkSecondaryDark: '#19b4b4',
  darkSecondary200: '#2cffff80',
  darkSecondary800: '#19b4b4cc',

  // text variants
  darkTextTitle: '#eeeeee',
  darkTextPrimary: '#dddddd',
  darkTextSecondary: '#969696'
};

export default themeCp0x;
